module.exports = __webpack_public_path__ + "media/images/search-99b328c0095716e3e50fa02aa44395f2.svg";